var map = {
	"./ca.json": "tbnx",
	"./cs.json": "xKuC",
	"./da.json": "NpdH",
	"./de.json": "+p6s",
	"./el.json": "/77A",
	"./en.json": "FSEc",
	"./es.json": "X9CH",
	"./fi.json": "Mwcz",
	"./fr.json": "7bvL",
	"./hu.json": "dwCx",
	"./it.json": "lDSc",
	"./nl.json": "K9zZ",
	"./no.json": "t5tc",
	"./pl.json": "uDoV",
	"./pt-br.json": "AOky",
	"./pt.json": "PNw8",
	"./ro.json": "loop",
	"./ru.json": "pEAk",
	"./supported-languages.json": "Ryd9",
	"./sv.json": "69OI",
	"./tr.json": "B05i"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+YTk";